__webpack_require__.p = "https://nivedhchag.github.io/NEEVNEXT/";